var ArrivalModel = require("../models/ArrivalModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

/**
 * @method RecentArrivalsWS
 * @param {*} viewModel 
 * @returns {RecentArrivalsWS}
 */
function RecentArrivalsWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = 'RecentArrivalsWS';
  self.spots = ko.observableArray([]);


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    var ids = (self.parent.id) ? [self.parent.id] : (self.parent.parent) ? self.parent.parent.selectedQueueIds() : [];

    // trim ids to only those that the user is a resource admin
    ids = ids.reduce(function (arr, id) {
      if (vm.hasRole('resourceAdmin.' + id)) {
        arr.push(id);
      }
      return arr;
    }, []);

    return (ids.length > 0) ? '/qless/api/v1/employee/queues/' + ids.join(',') + '/recentArrivals' : null;
  }, self, { deferEvaluation: true });


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {LocationsWS}
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);
    var spots = Array.makeArray(json.arrivals.arrival);
    var spotModels = [];

    spots.forEach(function (spot) {
      spotModels.push(new ArrivalModel(spot));
    });

    self.spots(spotModels);

    return self;
  };


	/**
	* Returns the object to it's initial state
	*
	* @method reset
	* @returns none
	*/
  self.reset = function () {
    // Remove any queues
    self.spots.removeAll();

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);
  }

  return self;
};

RecentArrivalsWS.prototype = AbstractWS.prototype;
RecentArrivalsWS.prototype.constructor = RecentArrivalsWS;

module.exports = RecentArrivalsWS;
